import { render } from "./AddVideo.vue?vue&type=template&id=7ce97d8a&scoped=true"
import script from "./AddVideo.vue?vue&type=script&lang=js"
export * from "./AddVideo.vue?vue&type=script&lang=js"

import "./AddVideo.vue?vue&type=style&index=0&id=7ce97d8a&lang=scss&scoped=true"

import exportComponent from "/Users/mohamedyousef/projects/online_education/projects/web-applications/admin-panel-for-education-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce97d8a"]])

export default __exports__